import type { FaqItem } from './faq.data'

export const BREAKUP_COMPARISON = {
  prompt: 'Мы расстались. Мне очень плохо. Не могу перестать думать о нём.',
  gpt: 'Мне жаль, что вы переживаете расставание. Вот несколько рекомендаций:\nДайте себе время пережить эмоции.\nОграничьте общение с бывшим партнёром.\nПроводите больше времени с близкими.\nЗаймитесь любимым делом.',
  hq: 'Похоже, сейчас очень больно. После расставания мысли о человеке могут возвращаться снова и снова.\n\nДавайте попробуем разобраться. Что мучает вас сильнее: тоска по нему, надежда всё вернуть или страх остаться одной?',
  callout: 'ChatGPT предлагает общие советы. Humanteq помогает разобраться в чувствах, определить этап расставания и шаг за шагом двигаться к восстановлению.',
}

// Approved FAQ copy. Privacy and history deletion await confirmed public wording.
export const BREAKUP_FAQ_ITEMS: FaqItem[] = [
  {
    q: 'Подойдёт ли Хьюмантек именно мне?',
    a: ['Если вы думаете о расставании, недавно расстались или снова возвращаетесь к тяжёлым переживаниям после разрыва, Хьюмантек может помочь разобраться в ситуации, пережить острые моменты и двигаться дальше небольшими шагами.'],
  },
  {
    q: 'Подойдёт ли мне Хьюмантек, если мы ещё не расстались?',
    a: ['Да. Необязательно ждать расставания. Хьюмантек подходит и тем, кто только думает о нём, сомневается в отношениях или пытается понять, стоит ли оставаться вместе. Приложение не принимает решение за вас.'],
  },
  {
    q: 'Как работает Хьюмантек?',
    a: ['Хьюмантек помогает разобраться, что происходит с отношениями сейчас, пройти период расставания и постепенно вернуться к себе. Можно поговорить о ситуации, определить свой этап, воспользоваться SOS-практикой или получить следующий шаг на день или неделю.'],
  },
  {
    q: 'Как понять, на каком этапе я нахожусь?',
    a: ['Можно пройти короткую диагностику. Она поможет определить вашу текущую точку и понять, что сейчас происходит с вами и отношениями. Этап может меняться — к диагностике можно возвращаться снова.'],
  },
  {
    q: 'Что делать, если меня сильно накрыло?',
    a: ['Для таких моментов есть SOS-режим. Он предлагает короткие практики, которые можно сделать прямо сейчас, когда трудно успокоиться, мысли ходят по кругу или появляется сильное желание написать бывшему партнёру.'],
  },
  {
    q: 'Что такое «Путь восстановления»?',
    a: ['Это ваш маршрут внутри Хьюмантек: где вы сейчас, что уже удалось пройти и на чём лучше сосредоточиться дальше.'],
  },
  {
    q: 'Что такое задания в «Пути»?',
    a: ['Небольшое действие на сегодня или на ближайшую неделю — прямо на экране «Путь». Вместо большого плана восстановления Хьюмантек помогает двигаться постепенно.'],
  },
  {
    q: 'Какие методики используются?',
    a: ['В основе — модель девяти стадий расставания, объединяющая подходы Стива Дака и Джона Ли, а также техники КПТ и ДБТ. Они помогают понять своё состояние, справиться с эмоциями и постепенно восстановиться после расставания.'],
  },
  {
    q: 'Может ли Хьюмантек заменить психолога?',
    a: ['Нет. Хьюмантек — инструмент поддержки и самостоятельной работы, а не замена психотерапии или медицинской помощи.'],
  },
  {
    q: 'Как отменить подписку?',
    a: [
      'Откройте «Настройки» в приложении. Если в блоке текущего тарифа есть кнопка «Отменить подписку», нажмите её: автопродление отключится, а доступ сохранится до конца оплаченного периода.',
      'Для подписки через RuStore управление доступно в Android-приложении: «Настройки» → «Управлять подпиской». Если нужной кнопки нет, обратитесь в раздел «Поддержка».',
    ],
    link: { text: 'Открыть настройки', href: '/settings' },
  },
  {
    q: 'Что делать, если остались вопросы?',
    a: ['Откройте раздел «Поддержка» в приложении и нажмите «Написать в поддержку» — откроется чат со службой поддержки Хьюмантек.'],
    link: { text: 'Открыть поддержку', href: '/support' },
  },
]
